import { render } from "./LogedInParts.vue?vue&type=template&id=806d21a2&scoped=true"
import script from "./LogedInParts.vue?vue&type=script&lang=js"
export * from "./LogedInParts.vue?vue&type=script&lang=js"

import "./LogedInParts.vue?vue&type=style&index=0&id=806d21a2&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806d21a2"]])

export default __exports__